$(document).ready(function () {

    // semantic-ui drowdown
    $('.dropdown').dropdown(/*{ fullTextSearch: true }*/);

});
